import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import usePriceCalculation from '@/src/hooks/itinerary/usePriceCalculation'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import ItineraryFooter from './itineraryFooter'

interface ItineraryFooterWrapperProps {
    onContinueClick: () => void
    isUpdateItineraryLoading: boolean
    buttonCta?: string
}

const ItineraryFooterWrapper = ({
    onContinueClick,
    isUpdateItineraryLoading,
    buttonCta
}: ItineraryFooterWrapperProps) => {
    const [breakupDrawerOpen, setBreakupDrawerOpen] = useState(false)
    const tCommon = useTranslations('common')
    const toggleBreakupDrawer = useCallback(() => setBreakupDrawerOpen(open => !open), [])

    const { totalPrice } = usePriceCalculation()
    const { formatCurrency } = useFormatCurrencyForItinerary()
    return (
        <ItineraryFooter
            price={totalPrice}
            isUpdateItineraryLoading={isUpdateItineraryLoading}
            breakupDrawerOpen={breakupDrawerOpen}
            tCommon={tCommon}
            buttonCta={buttonCta}
            formatCurrency={formatCurrency}
            onContinue={onContinueClick}
            toggleBreakupDrawer={toggleBreakupDrawer}
        />
    )
}

export default ItineraryFooterWrapper
